import { getWebp, getMp4 } from 'shared/util/gif-extract'

const player = (gif, renditionFilename) => {
    const extension = renditionFilename.split('.').pop()
    const proxyUrl = `https://i.giphy.com`
    const renditionFileUrl = `${proxyUrl}/media/${gif.id}/${renditionFilename}`
    const giphyGifUrl = `${proxyUrl}/${gif.id}.gif`
    const giphyMp4Url = `${proxyUrl}/${gif.id}.mp4`

    if (extension === 'mp4') {
        return `<video src="${renditionFileUrl}" 
                autoplay loop muted playsinline
                onerror="this.onerror=()=>{};this.src='${giphyMp4Url}';">
                <img src="${giphyGifUrl} " alt="" />
            </video>`
    } else {
        return `<img src="${renditionFileUrl}" 
                onerror="this.onerror=null;this.src='${giphyGifUrl}';"
                alt="" 
            />`
    }
}

const dynamicRendition = (gif, isWebpSupported) => {
    const { isSticker } = gif

    if (isSticker) {
        return player(gif, `giphy.gif`)
    } else if (isWebpSupported && getWebp(gif)) {
        return player(gif, `giphy.webp`)
    } else if (!global.isMobile && getMp4(gif)) {
        return player(gif, `giphy.mp4`)
    }

    return player(gif, 'giphy.gif')
}

export default function(gif, renditionFilename, isWebpSupported) {
    if (renditionFilename === 'giphy.gif') {
        return dynamicRendition(gif, isWebpSupported)
    } else {
        return player(gif, renditionFilename)
    }
}
